<template>
  <div class="initPage" v-if="isShowAll">
    <!--   -->
    <div v-if="isShow" id="home">
      <!-- <img
        class="initPageImage"
        src="https://cfb-bucket.oss-cn-beijing.aliyuncs.com/static/head-logo.png"
        alt=""
      /> -->
      <div class="initPageTitle">欢迎使用智能问答助手</div>
      <div class="card-wrap">
        <div class="card_b" @click="openDialogue(1)">
          <div class="card_b__top">
            <img src="../../chatRobot/image/ai.png" alt="avatar" />
          </div>
          <div class="card_b__cont">
            <h2>对话场景</h2>
            <div class="card_b__bottom">
              <p class="line-clamp-2">
                你好！我是智能问答助手，请描述你的问题
              </p>
            </div>
          </div>
        </div>

        <div class="card_b" @click="openDialogue(2)">
          <div class="card_b__top">
            <img src="../../chatRobot/image/write.png" alt="avatar" />
          </div>
          <div class="card_b__cont">
            <h2>写作模式</h2>
            <div class="card_b__bottom">
              <p class="line-clamp-2">
                你好！我是智能问答助手，请描述你的问题
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-desc">点击以上话题，快速与我对话</div>
    </div>

    <!--   -->

    <div v-else>
      <div style="display: flex">
        <chat-frame
          v-on="$listeners"
          ref="chatFrame"
          @again="again"
        ></chat-frame>
        <!-- <right-frame ref="rightFrame" @getContent="getContentL"></right-frame> -->
      </div>
    </div>
  </div>
</template>

<script>
import chatFrame from '../chatFrame/index.vue'
export default {
  data() {
    return {
      lietNum: 0,
      isShow: true,
      isShowAll: true,
      textList: [
        {
          title: '获取更好的答案',
          center: '“什么是循环流化床发电？”',
          image: require('../image/icon1.png')
        }
      ]
    }
  },
  components: { chatFrame },
  methods: {
    // 打开对话模式
    openDialogue(type) {
      this.$emit('dialogue', type)
    },
    cl() {
      this.isShow = false
    },
    close() {
      this.isShow = true
    },
    again(problem) {
      this.$emit('againProblem', problem)
    },
    clearList() {
      this.$refs.chatFrame.clear()
    },
    init(res) {
      console.log('initPage', res)
      this.lietNum++
      this.$nextTick(() => {
        if (this.$refs.chatFrame) {
          this.$refs.chatFrame.init(res)
        }
        // if (res.type === 1) this.$refs.rightFrame.init()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-desc{
  text-align center;
  color #999;
  margin-top 30px;
}
.card-wrap{
  display flex;
  justify-content center;
  margin-top:50px;
}
.card_b{
    width:400px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 8px 8px 20px 0 rgba(55,99,170,.1);
    cursor: pointer;
    // margin: 0 20px 16px 0;
    padding: 32px;
    position: relative;
    transition: all .2s ease;
    will-change: transform;
    display:flex;
    flex-direction: column;
    &:first-child{
    margin-right:30px
    }
    &:hover {
          background-color: rgba(72,114,246,0.7);
          background-image: none;
          box-shadow: none;
          transform: scale3d(.985,.985,.985) translateX(0);
          .card_b__cont{
            h2::before {
               display: none;
            }
          }
      }
     .card_b__top {
        align-items: center;
        display: flex;
        justify-content: flex-start;
        position: relative;
        img{
            width: 40px;
            height: 40px;
            margin: 0 auto;
            // margin-right: 24px;

        }
    }
    .card_b__cont{
      display:flex;
      flex-direction: column;
      text-align:left;
      margin-top:20px;
      text-align center;
      h2::before {
          background-color: #d8dde6;
          content: "";
          display: block;
          height: 1px;
          position: relative;
          top: 30px;
          width: 100%;
      }
    }
    .card_b__bottom {
        margin-top: 24px;
        position: relative;
    }
}
.initPage::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.initPage::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.initPage::-webkit-scrollbar-track {
  -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.flip-up {
  opacity: 0;
  transform: translateY(-100%);
}
.initPage {
  text-align: center;
  letter-spacing: 1px;
  margin-top: 46px;
  height: 447px;
  overflow-y: auto;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
  #home {
    transition: all 1s ease-in-out;
  }
  .flex {
    display: flex;
    padding: 0 64px;
    .flexItem {
      width: 300px;
      margin-right: 36px;
    }
    .flexItemTitle {
      display: flex;
      width: fit-content;
      margin: 0 auto;
      img {
        width: 24px;
        height: 24px;
      }
      div {
        line-height: 24px;
        padding: 0 0 0 6px;
      }
    }
    .flexItemCenter {
      width: 300px;
      height: 90px;
      background: #ffffff;
      border-radius: 8px;
      opacity: 0.85;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      line-height: 26px;
      letter-spacing: 2px;
      padding: 19px 30px;
      margin-top: 22px;
    }
  }
  .initPageImage {
    width: 400px;
    height: 72px;
  }
  .initPageTitle {
    width: 100%;
    font-size: 30px;
    font-family: FZLTCHK--GBK1-0, FZLTCHK--GBK1;
    text-align: center;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    padding: 30px 0 14px 0;
  }
  .initPageTitle2 {
    width: 100%;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    padding-bottom: 58px;
  }
  .initPageTitleEnd {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 14px;
    margin: 50px 0 41px 0;
  }
}
</style>
